<template>
  <div class="content">
    <h2 class="text-2xl font-bold mb-4">About Advertisements</h2>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Why does the site have advertisements?</h3>
      <p>Spin the Names is provided as a free service, and advertisements help cover the costs of development,
        server hosting, and maintenance. The ads are kept as unobtrusive as possible while still generating enough
        to support the platform and the developer's family.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">How are ads used to support the site?</h3>
      <p>The revenue generated from advertisements directly supports:</p>
      <ul class="list-disc ml-6 mt-2">
        <li>Server and hosting costs</li>
        <li>Development of new features</li>
        <li>Maintenance and bug fixes</li>
        <li>Support for multiple languages and accessibility improvements</li>
        <li>Providing me with a small income for my work on this project</li>
      </ul>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Can I use the app without ads?</h3>
      <p>Currently, Spin the Names doesn't offer an ad-free subscription option. However, the app is continuously
        improved to ensure that advertisements don't interfere with your experience using the wheel. The core
        functionality is always available without limitations, regardless of ads.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">What types of ads are shown?</h3>
      <p>Spin the Names works with reputable ad networks and strives to display appropriate content. If you ever
        encounter an ad that you believe is inappropriate or problematic, please contact ash@spinthenames.com, and
        the issue will be addressed promptly.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Do ads affect the performance of the wheel?</h3>
      <p>Spin the Names is optimized to ensure that advertisements don't impact the performance or randomness of
        the wheel. This was one of the key improvements to the original project—making sure the core functionality
        operates smoothly regardless of the ad-serving system.</p>
    </div>

    <p class="mt-8 text-sm"><a href="#top" class="text-blue-500 hover:underline">Back to top</a></p>
  </div>
</template>

<script setup>
import '@components/ui/faq/faqStyles.css';
</script>
